import { FormContainer } from 'components';
import { useTranslation } from 'libs/i18n';

import {
  CompanyRegistrationPlaceFormType,
  FormErrors,
  getSchema,
} from '../../forms/companyRegistrationPlaceForm';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  initialValues?: CompanyRegistrationPlaceFormType;
  onSubmit: (values: CompanyRegistrationPlaceFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitDisabled?: boolean;
  submitLoading?: boolean;
}

export const CompanyRegistrationPlace = ({
  initialValues,
  canGoBack,
  onGoBack,
  submitLoading,
  submitDisabled,
  formError,
  onSubmit,
  ...formProps
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema();
  return (
    <FormContainer
      canGoBack={canGoBack}
      initialErrors={formError}
      initialValues={initialValues}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={t('onboarding.companyRegistrationPlace.subtitle')}
      title={t('onboarding.companyRegistrationPlace.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <FormContent {...formProps} />
    </FormContainer>
  );
};
